
import bgImage from '../../../../asset/images/antartica.png';
export function HeroSection() {
  return (
    <section className="relative min-h-screen bg-cover bg-center bg-no-repeat" 
             style={{
               backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${bgImage})`
             }}>
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative z-10 container mx-auto px-6 py-32 lg:py-40">
        <div className="max-w-4xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
           The Seventh Continent
          </h1>
          <div className="prose prose-lg text-white max-w-none">
            <p className="text-lg leading-relaxed mb-6">
              Journey to the southernmost edge of the planet and experience the awe-inspiring wonder of Antarctica, a destination like no other on Earth. This frozen frontier is a realm of dazzling white landscapes, towering icebergs sculpted by time, and vast glaciers that stretch beyond the horizon. Despite its harsh environment, Antarctica teems with life — colonies of penguins waddle along icy shores, seals rest on floating ice, and majestic whales breach through the frigid waters of the Southern Ocean.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Exploring Antarctica is not just a trip; it's a transformative experience. Cruise through the Lemaire Channel surrounded by towering ice cliffs, set foot on ancient ice sheets where few have walked, and witness the surreal midnight sun casting golden hues over an endless expanse of snow. Scientists and adventurers alike are drawn to this land for its pristine ecosystems and its powerful reminder of Earth's fragility and resilience.
            </p>
            
             <button className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  Explore SIghtseeing
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center ml-2"></i>
             </button>
          </div>
        </div>
      </div>
    </section>
  );
}
